<mat-accordion class="custom-mat-accordion">
  @for (panel of panels(); track panel.title(); let last = $last) {
    <mat-expansion-panel>
      <mat-expansion-panel-header>
        <mat-panel-title>{{ panel.title() }}</mat-panel-title>

        @if (panel.formGroup()?.dirty) {
          <span class="custom-icon-validator">
            <svg>
              <use
                [attr.href]="
                  panel.formGroup()?.valid
                    ? 'assets/images/ok-icons-sprite.svg#state-available'
                    : 'assets/images/ok-icons-sprite.svg#state-faulted'
                "></use>
            </svg>
          </span>
        }
        @if (!panel.formGroup()?.dirty && panel.formGroup()?.valid) {
          <span class="custom-icon-validator">
            <svg>
              <use [attr.href]="'assets/images/ok-icons-sprite.svg#state-available'"></use>
            </svg>
          </span>
        }
      </mat-expansion-panel-header>
      <ng-container *ngTemplateOutlet="panel.template" />
      @if (!last) {
        <div class="flex button-container">
          <button mat-raised-button color="secondary" class="custom-btn-next" (click)="next(panel)" [disabled]="!panel.formGroup()?.valid">
            Videre
          </button>
        </div>
      }
    </mat-expansion-panel>
  }
</mat-accordion>
